import React from "react";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "../../ui/dropdown-menu";
import { FolderInput, Folder } from "lucide-react";

interface MoveToFolderMenuProps {
  folders: Array<{
    _id: string;
    name: string;
    color: string;
  }>;
  onMoveToFolder: (folderId: string | null) => void;
  currentFolderId?: string | null;
}

const MoveToFolderMenu: React.FC<MoveToFolderMenuProps> = ({
  folders,
  onMoveToFolder,
  currentFolderId,
}) => {
  const { t } = useTranslation();

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <FolderInput  className="ml-2 mr-2 mt-1 w-[15px]" />
        <span>{t("move_to_folder")}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        {/* No Folder Option */}
        <DropdownMenuItem
          onClick={() => onMoveToFolder(null)}
          disabled={!currentFolderId}
        >
          <div className="flex items-center gap-2">
            <div
                className="w-4 h-4 rounded flex items-center justify-center"
                style={{ backgroundColor: '#6B7280' }}
            >
            </div>
            <span>{t('no_folder')}</span>
          </div>
        </DropdownMenuItem>

        {/* Folder List */}
        {folders.map((folder) => (
          <DropdownMenuItem
            key={folder._id}
            onClick={() => onMoveToFolder(folder._id)}
            disabled={currentFolderId === folder._id}
          >
            <div className="flex items-center gap-2">
              <div
                className="w-4 h-4 rounded flex items-center justify-center"
                style={{ backgroundColor: folder.color }}
              >
                <Folder className="w-3 h-4 text-white font-bold" />
              </div>
              <span>{folder.name}</span>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};

export default MoveToFolderMenu;
